import ChecklistLogbooks from "src/components/pages/Settings/Miscellaneous/CheckLists/ChecklistLogbooks/ChecklistLogbooks";
import { CheckListsProvider } from "src/components/pages/Settings/Miscellaneous/CheckLists/CheckListsContext";
import CheckListsHeader from "src/components/pages/Settings/Miscellaneous/CheckLists/CheckListsHeader";
import { PageContainer } from "src/styled";

const CheckLists = () => {
  return (
    <CheckListsProvider>
      <PageContainer>
        <CheckListsHeader />
        <ChecklistLogbooks />
      </PageContainer>
    </CheckListsProvider>
  );
};

export default CheckLists;
